import { useUser } from "@clerk/react";
import { Link as RouterLink } from "react-router";
import { ArrowRightIcon } from "@phosphor-icons/react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { warmGlowBackground } from "@scoutingops/ui";

import { paths } from "@/paths";

const HUB_URL = (import.meta.env.VITE_HUB_URL ?? "https://scoutingops.com") as string;

export default function CtaSection() {
  const { isSignedIn } = useUser();

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, position: "relative", overflow: "hidden", textAlign: "center" }}>
      {/* Warm brand glow closing out the page, echoing the hero */}
      <Box
        aria-hidden
        sx={{ background: warmGlowBackground, inset: 0, pointerEvents: "none", position: "absolute" }}
      />
      <Container maxWidth="sm" sx={{ position: "relative" }}>
        <Typography variant="h4" sx={{ fontWeight: 700 }} gutterBottom>
          Ready to get started?
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Sign in to Scouting Ops and publish your unit&apos;s site — or join the waitlist to be
          notified when your unit can get access.
        </Typography>
        <Stack direction="row" spacing={2} sx={{ justifyContent: "center", flexWrap: "wrap", gap: 2 }}>
          {isSignedIn ? (
            <Button
              component={RouterLink}
              to={paths.studio}
              variant="contained"
              size="large"
              endIcon={<ArrowRightIcon size={18} />}
            >
              Open Studio
            </Button>
          ) : (
            <>
              <Button
                component="a"
                href={`${HUB_URL}/auth/sign-in`}
                variant="contained"
                size="large"
              >
                Sign In
              </Button>
              <Button
                component="a"
                href={`${HUB_URL}/auth/waitlist`}
                variant="outlined"
                size="large"
              >
                Join the Waitlist
              </Button>
            </>
          )}
        </Stack>
      </Container>
    </Box>
  );
}
